import "./styles.scss";
import navigation from "./components/navigation.html";
import hero from "./components/hero.html";
import marquee from "./components/marquee.html";
import features from "./components/features.html";
import pro from "./components/pro.html";
import testimonials from "./components/testimonials.html";
import pricing from "./components/pricing.html";
import cta from "./components/cta.html";
import footer from "./components/footer.html";

document.getElementById("app").innerHTML = `
<div class="space-bg" aria-hidden="true"></div>
${navigation}
<main>
${hero}
${marquee}
${features}
${pro}
${testimonials}
${pricing}
${cta}
</main>
${footer}
`;

/* ------------------------------------------------------------------ */
/* Hero space-image slideshow (cross-fades the stacked browser shots)  */
/* ------------------------------------------------------------------ */
(function heroSlideshow() {
  const imgs = document.getElementsByClassName("hero__browser-image");
  if (!imgs.length) return;
  let loadedCount = 0;

  function onLoaded() {
    loadedCount++;
    if (loadedCount !== imgs.length) return;

    for (let img of imgs) img.classList.add("hero__browser-image-loaded");

    const credits = document.getElementsByClassName("hero__browser-image-credit");
    for (let credit of credits) credit.style.opacity = 1;

    const slideshow = document.getElementById("slideshow");
    const slides = slideshow.getElementsByTagName("div");
    const cycle = () => slideshow.appendChild(slides[0]);
    for (let i = 0; i < slides.length; i++) {
      slides[i].addEventListener("animationend", cycle, false);
    }
  }

  for (let img of imgs) {
    const current = img.firstElementChild;
    if (current.complete) {
      onLoaded();
    } else {
      current.addEventListener("load", onLoaded);
      current.addEventListener("error", onLoaded);
    }
  }
})();

/* ------------------------------------------------------------------ */
/* "Daily space images" feature card: same cross-fade as the hero      */
/* ------------------------------------------------------------------ */
(function spaceSlideshow() {
  const container = document.getElementById("space-slideshow");
  if (!container) return;
  const slides = container.getElementsByClassName("bento__slide");
  if (!slides.length) return;
  let loadedCount = 0;

  function onLoaded() {
    loadedCount++;
    if (loadedCount !== slides.length) return;

    for (let slide of slides) slide.classList.add("bento__slide-loaded");

    const cycle = () => container.appendChild(slides[0]);
    for (let slide of slides) {
      slide.addEventListener("animationend", cycle, false);
    }
  }

  for (let slide of slides) {
    const img = slide.firstElementChild;
    if (img.complete) {
      onLoaded();
    } else {
      img.addEventListener("load", onLoaded);
      img.addEventListener("error", onLoaded);
    }
  }
})();

/* ------------------------------------------------------------------ */
/* Sticky nav: shrink on scroll, hide on scroll-down / show on up      */
/* ------------------------------------------------------------------ */
(function stickyNav() {
  const header = document.getElementById("site-header");
  if (!header) return;
  let lastY = window.scrollY;
  let ticking = false;

  function update() {
    const y = window.scrollY;
    header.classList.toggle("is-scrolled", y > 8);

    // Don't hide while the mobile menu is open.
    if (!header.classList.contains("is-open")) {
      if (y > 120 && y > lastY) {
        header.classList.add("is-hidden");
      } else {
        header.classList.remove("is-hidden");
      }
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
  update();
})();

/* ------------------------------------------------------------------ */
/* Mobile menu toggle                                                  */
/* ------------------------------------------------------------------ */
(function mobileMenu() {
  const header = document.getElementById("site-header");
  const toggle = document.getElementById("nav-toggle");
  const menu = document.getElementById("nav-menu");
  if (!header || !toggle || !menu) return;

  const setOpen = (open) => {
    header.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  };

  toggle.addEventListener("click", () => {
    const willOpen = !header.classList.contains("is-open");
    setOpen(willOpen);
    if (willOpen && typeof window.op === "function") {
      window.op("track", "menu_opened");
    }
  });

  menu.querySelectorAll("a").forEach((link) =>
    link.addEventListener("click", () => setOpen(false))
  );

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setOpen(false);
  });
})();

/* ------------------------------------------------------------------ */
/* Reveal-on-scroll                                                    */
/* ------------------------------------------------------------------ */
(function revealOnScroll() {
  const els = document.querySelectorAll(".reveal");
  if (!els.length) return;

  if (!("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
  );

  els.forEach((el) => io.observe(el));
})();

/* ------------------------------------------------------------------ */
/* Scroll funnel: fire a one-shot `section_viewed` event (via OpenPanel) */
/* as each major section scrolls into view, so we can see how far down   */
/* the hero → pricing journey people get before they bounce.             */
/* ------------------------------------------------------------------ */
(function sectionFunnel() {
  if (typeof window.op !== "function" || !("IntersectionObserver" in window)) {
    return;
  }

  // [selector, section name] — order mirrors the page top-to-bottom.
  const sections = [
    [".hero", "hero"],
    ["#features", "features"],
    ["#pro", "pro"],
    ["#reviews", "reviews"],
    ["#pricing", "pricing"],
    [".final-cta", "final-cta"],
  ];

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        window.op("track", "section_viewed", {
          section: entry.target.dataset.funnelSection,
        });
        io.unobserve(entry.target);
      });
    },
    // threshold 0 + a bottom margin fires when a section's top crosses ~75%
    // down the viewport — reliable even for sections taller than the screen.
    { threshold: 0, rootMargin: "0px 0px -25% 0px" }
  );

  sections.forEach(([selector, name]) => {
    const el = document.querySelector(selector);
    if (!el) return;
    el.dataset.funnelSection = name;
    io.observe(el);
  });
})();

/* ------------------------------------------------------------------ */
/* Lazy-play widget preview videos only while they're on screen        */
/* (preload="none" + data-src keeps the 6 S3 clips off the critical    */
/* path; we attach the source and play as each card scrolls in.)       */
/* ------------------------------------------------------------------ */
(function lazyVideos() {
  const videos = document.querySelectorAll(".pro-card__video, .bento__video");
  if (!videos.length) return;

  const attach = (video) => {
    if (video.dataset.src && !video.src) {
      video.src = video.dataset.src;
    }
  };

  if (!("IntersectionObserver" in window)) {
    videos.forEach((v) => {
      attach(v);
      v.play().catch(() => {});
    });
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          attach(video);
          video.classList.add("is-ready");
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.35 }
  );

  videos.forEach((v) => io.observe(v));
})();
